/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard, DashbordGuard } from '@lcms/shared/data-access-user';
import { SearchPageComponent } from 'apps/shell/src/app/modules/admin/components/search-page/search-page.component';
import { LayoutComponent } from 'apps/shell/src/app/modules/_metronic/layout/layout.component';
import { AdminModule } from 'apps/shell/src/app/modules/admin/admin.module';
import {SearchPageFormationComponent} from "@lcms/shared/search-formation";


const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'survey',
        loadChildren: () =>
          import('mfe-survey/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: 'centre-notifications',
        loadChildren: () =>
          import('mfe-notifications/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: 'admin',
        canLoad: [AdminGuard],
        data: { role: 'administrator' },
        loadChildren: () =>
        import('apps/shell/src/app/modules/admin/admin.module').then((m) => m.AdminModule)
        ,
      },
      {
        path: 'catalogue',
        loadChildren: () =>
        import('mfe-catalogue/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: 'formation',
        loadChildren: () =>
          import('mfe-enrolement/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: 'formation/:id',
        loadChildren: () =>
          import('mfe-enrolement/Module').then((m) => m.RemoteEntryModule),
      },
      // {
      //   path: 'calendrier',
      //   loadChildren: () =>
      //     import('mfe-calendar/Module').then((m) => m.RemoteEntryModule),
      // },
      {
        path: 'rapports',
        loadChildren: () =>
        import('mfe-report/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: 'evaluations',
        loadChildren: () =>
          import('mfe-evaluations/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: 'search',
        component: SearchPageComponent
      },
      {
        path: 'search-Formation',
        component: SearchPageFormationComponent
      },
      {
        path: 'account',
        loadChildren: () =>
          import('mfe-profile/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: 'help',
        loadChildren: () =>
          import('mfe-help/Module').then((m) => m.RemoteEntryModule),
      },
      // {
      //   path: 'lexique',
      //   loadChildren: () =>
      //     import('mfe-lexique/Module').then((m) => m.RemoteEntryModule),
      // },
      {
        path: 'passport',
        loadChildren: () =>
          import('mfe-passport/Module').then((m) => m.RemoteEntryModule),
      },
      // {
      //   path: 'faq',
      //   loadChildren: () =>
      //     import('mfe-faq/Module').then((m) => m.RemoteEntryModule),
      // },
      {
        path: 'docs',
        loadChildren: () =>
          import('mfe-document/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: '',
        // canMatch: [DashbordGuard],
        // data: { role: 'administrator' },
        loadChildren: () =>
          import('mfe-dashbord-admin/Module').then((m) => m.RemoteEntryModule),
      },
      {
        path: 'tags',
        loadChildren: () =>
          import('mfe-tags/Module').then((m) => m.RemoteEntryModule),
      },
      // {
      //   path: 'permissions',
      //   loadChildren: () =>
      //     import('mfe-access/Module').then((m) => m.RemoteEntryModule),
      // },
      // {
      //   path: '',
      //   canMatch: [DashbordGuard],
      //   data: { role: 'manager' },
      //   loadChildren: () =>
      //     import('mfe-dashbord-admin/Module').then((m) => m.RemoteEntryModule),
      // },
      // {
      //   path: '',
      //   canMatch: [DashbordGuard],
      //   data: { role: 'tutor' },
      //   loadChildren: () =>
      //     import('mfe-dashbord-tutor/Module').then((m) => m.RemoteEntryModule),
      // },
      // {
      //   path: 'mobile',
      //   canMatch: [DashbordGuard],
      //   data: { role: 'learner' },
      //   loadChildren: () =>
      //     import('mfe-dashboard-learner-mobile/Module').then(
      //       (m) => m.RemoteEntryModule
      //     ),
      // },
      // {
      //   path: 'mobile',
      //   canMatch: [DashbordGuard],
      //   data: { role: 'tutor' },
      //   loadChildren: () =>
      //     import('mfe-dashboard-tutor-mobile/Module').then(
      //       (m) => m.RemoteEntryModule
      //     ),
      // },
      // {
      //   path: 'mobile',
      //   canMatch: [DashbordGuard],
      //   data: { role: 'administrator' },
      //   loadChildren: () =>
      //     import('mfe-dashboard-learner-mobile/Module').then(
      //       (m) => m.RemoteEntryModule
      //     ),
      // },
      // {
      //   path: '',
      //   canMatch: [DashbordGuard],
      //   data: { role: 'learner' },
      //   loadChildren: () =>
      //     import('mfe-dashbord-learner/Module').then(
      //       (m) => m.RemoteEntryModule
      //     ),
      // },
      {
        path: 'users',
        loadChildren: () =>
          import('mfe-users/Module').then((m) => m.RemoteEntryModule),
      },
      //  {
      //   path: '',
      //   loadChildren: () =>
      //     import('mfe-document/Module').then((m) => m.RemoteEntryModule),
      // }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class LayoutRoutingModule { }

